<template>
  <v-form ref="form" lazy-validation>
    <v-row>
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="shipping_rate.pickup_location_id"
          :items="pickup_locations"
          item-text="attributes.name"
          item-value="id"
          label="Local de Retira"
          prepend-icon="mdi-pin"
          :readonly="read_only"
          :rules="required"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="shipping_rate.region_id"
          :items="regions"
          item-text="name"
          item-value="id"
          label="Cidade"
          prepend-icon="mdi-map-marker"
          :readonly="read_only"
          :rules="required"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model.number="shipping_rate.kilometers"
          type="number"
          min="0"
          step="0.01"
          label="Kilometragem"
          prepend-icon="mdi-road-variant"
          :readonly="read_only"
          :rules="required"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="shipping_rate.unit_price"
          type="tel"
          v-money="money"
          label="Preço frete (R$)"
          prepend-icon="mdi-currency-usd"
          :readonly="read_only"
          :rules="required"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="shipping_rate.discharge_price"
          type="tel"
          v-money="money"
          label="Preço descarga (R$)"
          prepend-icon="mdi-package-down"
          :readonly="read_only"
          :rules="required"
        />
      </v-col>
      <v-col cols="12" class="pt-0">
        <span class="text-body-2 text--secondary">
          Preço final unitário:
          <b>{{ finalUnitPriceDisplay }}</b>
          (frete + descarga)
        </span>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import validations from "@/mixins/validations.js"
import { VMoney } from "v-money"

export default {
  name: "ShippingRateForm",
  directives: { money: VMoney },
  mixins: [validations],
  props: {
    shipping_rate: {
      type: Object,
      required: true,
    },
    pickup_locations: {
      type: Array,
      default: () => [],
    },
    regions: {
      type: Array,
      default: () => [],
    },
    read_only: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
    }
  },
  computed: {
    finalUnitPriceDisplay() {
      const parseMoney = (value) => {
        const normalized = String(value == null ? "" : value).replace(/\./g, "").replace(",", ".")
        const parsed = Number(normalized)
        return Number.isFinite(parsed) ? parsed : 0
      }
      return (parseMoney(this.shipping_rate?.unit_price) + parseMoney(this.shipping_rate?.discharge_price))
        .toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
    },
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
  },
}
</script>
